import React from 'react'
import { FaClock } from 'react-icons/fa'

const NotStartedStepMessage: React.FC = () => {
  return (
    <div className="empty-state-container text-center py-5">
      <div className="empty-state-icon mb-4">
        <FaClock size={64} className="text-muted" style={{ opacity: 0.4 }} />
      </div>
      <h4 className="mb-3">Etapa não iniciada</h4>
      <p className="text-muted mb-4" style={{ maxWidth: '600px', margin: '0 auto' }}>
        Essa etapa ficará disponível após a conclusão das etapas anteriores.
      </p>
    </div>
  )
}

export default NotStartedStepMessage
